import AbcIcon from '@mui/icons-material/Abc';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import ImageIcon from '@mui/icons-material/Image';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import {
  Box,
  Chip,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Switch,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ChatUserRole } from '@/types/graphql';
import { isChatEditor, isChatHost } from '@/utils/userRole';

const ChatMenu = (props: {
  userRole: ChatUserRole;
  isGuestInputRestricted: boolean;
  onClickParticipants: () => void;
  userCount: number;
  onClickRemoveAllUser: () => void;
  onClickClearMessages: () => void;
  onClickTogglePlayMessageEnabled: () => void;
  playMessageEnabled: boolean;
  onClickReverseTranslation: () => void;
  onClickSwitchReverseTranslation: (value: boolean) => void;
  onClickSendImage: () => void;
  onClickChatSettings: () => void;
  onClickFontSettings: () => void;
  onClickDeviceTest: () => void;
  onClickLeaveSession: () => Promise<void>;
  onClickToggleDisplayInformation: () => void;
  isHiddenInformation: boolean;
  isVoiceMode: boolean;
  onClickProjectionMode: () => void;
  onClickVadSettings: () => void;
  dualLangTranslation: boolean;
  isOnReverseTranslation: boolean;
}) => {
  const { t } = useTranslation('chat');

  const canGuideControl = isChatHost(props.userRole);
  const canEditControl = isChatEditor(
    props.isGuestInputRestricted,
    props.userRole
  );

  console.log('isHiddenInformation', props.isHiddenInformation);
  return (
    <Box display="grid" gridTemplateRows="1fr auto" height={1}>
      <MenuList>
        {canEditControl && (
          <MenuItem onClick={() => props.onClickParticipants()}>
            <ListItemIcon>
              <PeopleAltIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('menu.participants')} />
            <Chip label={props.userCount} size="small" sx={{ ml: 1, mr: 1 }} />
          </MenuItem>
        )}
        {canGuideControl && (
          <MenuItem onClick={() => props.onClickRemoveAllUser()}>
            <ListItemIcon>
              <GroupRemoveIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('menu.removeAllUsers')} />
          </MenuItem>
        )}
        {canEditControl && (
          <MenuItem onClick={() => props.onClickSendImage()}>
            <ListItemIcon>
              <ImageIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('menu.sendImage')} />
          </MenuItem>
        )}
        {canEditControl && (
          <MenuItem
            disabled={!props.isVoiceMode}
            onClick={() => props.onClickTogglePlayMessageEnabled()}
          >
            <ListItemIcon>
              <VolumeUpIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('menu.readAloud')} />
            <Switch
              checked={props.playMessageEnabled}
              sx={{ pointerEvents: 'none', my: '-100px', mr: -1 }}
            />
          </MenuItem>
        )}
        {canEditControl && (
          <MenuItem
            onClick={() => {
              props.onClickToggleDisplayInformation();
            }}
          >
            <ListItemIcon>
              <AbcIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('menu.informationDisplay')} />
            <Switch
              checked={!props.isHiddenInformation}
              sx={{ pointerEvents: 'none', my: '-100px', mr: -1 }}
            />
          </MenuItem>
        )}
        {canEditControl && (
          <MenuItem onClick={() => props.onClickProjectionMode()}>
            <ListItemIcon>
              <PersonalVideoIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('menu.projectionMode')} />
          </MenuItem>
        )}
        {canEditControl && (
          <>
            {props.dualLangTranslation && canGuideControl ? (
              <MenuItem
                onClick={() => {
                  props.onClickSwitchReverseTranslation(
                    !props.isOnReverseTranslation
                  );
                }}
              >
                <ListItemIcon>
                  <GTranslateIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={t('menu.reverseTranslation')} />
                <Switch
                  checked={!!props.isOnReverseTranslation}
                  sx={{ pointerEvents: 'none', my: '-100px', mr: -1 }}
                />
              </MenuItem>
            ) : (
              <MenuItem onClick={() => props.onClickReverseTranslation()}>
                <ListItemIcon>
                  <GTranslateIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={t('menu.reverseTranslation')} />
              </MenuItem>
            )}
          </>
        )}
        <MenuItem onClick={() => props.onClickChatSettings()}>
          <ListItemIcon>
            <ManageAccountsIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={t('menu.userSetting')} />
        </MenuItem>
        <MenuItem onClick={() => props.onClickFontSettings()}>
          <ListItemIcon>
            <FormatSizeIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={t('menu.fontSetting')} />
        </MenuItem>
        {canEditControl && (
          <MenuItem onClick={() => props.onClickDeviceTest()}>
            <ListItemIcon>
              <GraphicEqIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('settings.TestSpeakersAndMicrophones')} />
          </MenuItem>
        )}
        {canEditControl && (
          <MenuItem onClick={() => props.onClickVadSettings()}>
            <ListItemIcon>
              <GraphicEqIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('settings.vadPresetLabel')} />
          </MenuItem>
        )}
      </MenuList>
      {/* 退出ボタン */}
      {/* <MenuList>
        <Divider sx={{ mb: 1, mt: -1 }} />
        <MenuItem onClick={() => props.onClickLeaveSession()}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary={t('menu.leave')} />
        </MenuItem>
      </MenuList> */}
    </Box>
  );
};

export default ChatMenu;
